'use client';
import { useMobileNavStore } from '@/store/mobileNavStore';
import { SectionsSearch } from '@/types/sectionsSearch';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import IconCollection from './IconCollection/IconCollection';

export default function SearchModal({
  searchSection,
}: {
  searchSection?: SectionsSearch;
}) {
  const { isSearchOpen, closeSearch } = useMobileNavStore();
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();

  const { quickSearch, searchBar } = searchSection || {};
  const keywords = (quickSearch ?? [])
    .map((item) => ({
      id: item.id,
      keyword: item.keyword?.trim() ?? '',
    }))
    .filter((item) => item.keyword.length > 0);

  const handleSearch = () => {
    try {
      if (searchQuery && searchQuery.trim()) {
        router.push(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
      } else {
        router.push('/search');
      }
      closeSearch();
    } catch (error) {
      console.error('Failed to search:', error);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  if (!isSearchOpen) {
    return null;
  }

  return (
    <>
      <div className="it-search-modal-wrapper-backdrop" onClick={closeSearch} />

      <div className="it-search-modal-wrapper">
        <div className="">
          <button onClick={closeSearch} className="btn it-modal-go-back-btn">
            <IconCollection name="arrowLeft" />
            <span>INDIETRO</span>
          </button>
        </div>

        <div>
          <h2 className="it-modal-heading">
            {searchBar?.label || 'Cerca nel sito'}
          </h2>

          <div className="d-flex">
            <div className="it-input-container position-relative flex-grow-1">
              <div className="it-modal-icon-container">
                <IconCollection name={'blueSearch'} />
              </div>

              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyPress={handleKeyPress}
                className="form-control"
              />
            </div>

            <button onClick={handleSearch} className="btn submitBtn-search">
              {searchBar?.buttonLabel || 'Cerca'}
            </button>
          </div>
        </div>
        <span className="it-modal-instruction-text">
          {searchBar?.helperText ||
            `*Inserisci parole chiave, ad esempio “Vaccinazioni”`}
        </span>

        {keywords.length > 0 ? (
          <div>
            <h3 className="it-modal-list-heading mb-3">Ricerca rapida</h3>

            <div className="d-flex flex-column gap-3 it-modal-listing-items">
              {keywords.map((item, index) => (
                <Link
                  prefetch={false}
                  className="it-modal-listing-item"
                  key={item.id ?? `${item.keyword}-${index}`}
                  href={`/search?q=${encodeURIComponent(item.keyword)}`}
                  onClick={closeSearch}
                  aria-label={`Cerca ${item.keyword}`}
                >
                  {item.keyword}
                </Link>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
